import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import background from "./images/background.png";

const API = process.env.REACT_APP_API_URL || "";

const TABS = [
  { key: "global", label: "Global" },
  { key: "completa_frase", label: "Frases" },
  { key: "sopa_letras", label: "Sopas" },
];

export default function Leaderboard() {
  const { user, token } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("global");
  const [rankings, setRankings] = useState([]);
  const [myStats, setMyStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLeaderboard();
    if (token) fetchMyStats();
  }, [activeTab, token]);

  const fetchLeaderboard = async () => {
    setLoading(true);
    try {
      const res = await fetch(
        `${API}/api/scores/leaderboard?game=${activeTab}`
      );
      const data = await res.json();
      setRankings(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchMyStats = async () => {
    try {
      const res = await fetch(`${API}/api/scores/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (res.ok) setMyStats(data);
    } catch (err) {
      console.error(err);
    }
  };

  const isSeasonZero = rankings.length < 3;
  const top3 = rankings.slice(0, 3);
  const rest = rankings.slice(3);
  const podiumOrder = top3.length === 3 ? [top3[1], top3[0], top3[2]] : top3;
  const podiumHeights = { 0: "50px", 1: "68px", 2: "36px" };
  const podiumColors = { 0: "#c4b5fd", 1: "#f9a8d4", 2: "#7BDCFB" };
  const podiumPositions = { 0: 2, 1: 1, 2: 3 };

  return (
    <div
      className="flex flex-col font-quicksand"
      style={{
        backgroundImage: `url(${background})`,
        backgroundRepeat: "repeat-y",
        backgroundSize: "100% auto",
        backgroundPosition: "top center",
        minHeight: "calc(100vh - 120px)",
      }}
    >
      <div className="px-5 pt-6 pb-10 flex flex-col gap-4">
        {/* Header */}
        <div>
          <p
            style={{
              fontSize: "10px",
              fontWeight: 700,
              letterSpacing: "0.1em",
              color: "#b06ab3",
              textTransform: "uppercase",
              marginBottom: "4px",
            }}
          >
            Ranking
          </p>
          <h1
            style={{
              fontSize: "22px",
              fontWeight: 800,
              color: "#2d1f3d",
              lineHeight: 1.2,
            }}
          >
            ¿Quién es la más perrísima? 🏆
          </h1>
        </div>

        {/* Tabs */}
        <div
          style={{
            display: "flex",
            background: "rgba(255,255,255,0.9)",
            borderRadius: "20px",
            border: "1.5px solid #e8e0f0",
            overflow: "hidden",
            padding: "3px",
            gap: "3px",
          }}
        >
          {TABS.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              style={{
                flex: 1,
                padding: "8px 6px",
                fontSize: "12px",
                fontWeight: 700,
                border: "none",
                cursor: "pointer",
                fontFamily: "Quicksand, sans-serif",
                borderRadius: "16px",
                background: activeTab === tab.key ? "#b06ab3" : "transparent",
                color: activeTab === tab.key ? "white" : "#9b7eaa",
                transition: "all 0.2s",
              }}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {loading ? (
          <div
            style={{ textAlign: "center", padding: "40px 0", color: "#b06ab3" }}
          >
            Cargando...
          </div>
        ) : rankings.length === 0 ? (
          <div style={{ textAlign: "center", padding: "40px 0" }}>
            <p style={{ fontSize: "14px", color: "#9b7eaa" }}>
              Aún no hay puntuaciones 💙
            </p>
            <p style={{ fontSize: "12px", color: "#c4b5fd", marginTop: "8px" }}>
              ¡Sé la primera en aparecer aquí!
            </p>
          </div>
        ) : isSeasonZero ? (
          // ── SEASON ZERO STATE ──
          <>
            <div style={{ textAlign: "center" }}>
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "5px",
                  background:
                    "linear-gradient(135deg, rgba(176,106,179,0.12), rgba(123,220,251,0.12))",
                  border: "1.5px solid #c4b5fd",
                  borderRadius: "999px",
                  padding: "4px 14px",
                  fontSize: "10px",
                  fontWeight: 700,
                  color: "#b06ab3",
                  letterSpacing: "0.05em",
                }}
              >
                ✨ Season Zero · Era Fundadora
              </div>
            </div>

            {/* Spotlight del #1 */}
            {rankings[0] &&
              (() => {
                const entry = rankings[0];
                const initial = entry.username[0].toUpperCase();
                const isMe = user && entry.username === user.username;
                return (
                  <div
                    style={{
                      background: "rgba(255,255,255,0.92)",
                      borderRadius: "24px",
                      border: "1.5px solid #f9a8d4",
                      padding: "24px 18px 20px",
                      textAlign: "center",
                      boxShadow: "0 4px 20px rgba(176,106,179,0.1)",
                      position: "relative",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "20px",
                        position: "absolute",
                        top: "-12px",
                        left: "50%",
                        transform: "translateX(-50%)",
                      }}
                    >
                      👑
                    </div>
                    <div
                      style={{
                        width: "64px",
                        height: "64px",
                        borderRadius: "50%",
                        background: "linear-gradient(135deg, #b06ab3, #c4b5fd)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "24px",
                        fontWeight: 800,
                        color: "white",
                        margin: "0 auto 10px",
                        boxShadow: "0 4px 14px rgba(176,106,179,0.3)",
                      }}
                    >
                      {initial}
                    </div>
                    <p
                      style={{
                        fontSize: "16px",
                        fontWeight: 800,
                        color: "#2d1f3d",
                        marginBottom: "2px",
                      }}
                    >
                      @{entry.username}
                      {isMe && (
                        <span
                          style={{
                            fontSize: "11px",
                            color: "#7BDCFB",
                            marginLeft: "6px",
                          }}
                        >
                          tú
                        </span>
                      )}
                    </p>
                    <p
                      style={{
                        fontSize: "13px",
                        color: "#b06ab3",
                        fontWeight: 700,
                        marginBottom: "14px",
                      }}
                    >
                      #1 global · {parseInt(entry.total).toLocaleString()} pts
                    </p>

                    {/* Stats del #1 si es el usuario loggeado */}
                    {isMe && myStats && (
                      <div
                        style={{
                          display: "flex",
                          gap: "8px",
                          marginBottom: "14px",
                        }}
                      >
                        {[
                          { num: myStats.total, label: "pts globales" },
                          { num: `#${myStats.rank}`, label: "ranking" },
                        ].map((s, i) => (
                          <div
                            key={i}
                            style={{
                              flex: 1,
                              background: "#f8f4ff",
                              borderRadius: "12px",
                              padding: "8px",
                              textAlign: "center",
                            }}
                          >
                            <p
                              style={{
                                fontSize: "16px",
                                fontWeight: 800,
                                color: "#b06ab3",
                                margin: 0,
                              }}
                            >
                              {s.num}
                            </p>
                            <p
                              style={{
                                fontSize: "9px",
                                color: "#9b7eaa",
                                fontWeight: 600,
                                marginTop: "2px",
                              }}
                            >
                              {s.label}
                            </p>
                          </div>
                        ))}
                      </div>
                    )}

                    <div
                      style={{
                        fontSize: "12px",
                        color: "#9b7eaa",
                        lineHeight: 1.55,
                        background: "#f8f4ff",
                        borderRadius: "12px",
                        padding: "10px 12px",
                        marginBottom: "14px",
                        textAlign: "left",
                      }}
                    >
                      👀 Pocas fans han llegado aquí. Eres parte de la era
                      fundadora de KarimeSays. Tu lugar en la historia empieza
                      ahora.
                    </div>

                    <button
                      onClick={() => navigate("/select-game")}
                      style={{
                        background: "linear-gradient(135deg, #7BDCFB, #6ec6f5)",
                        border: "none",
                        borderRadius: "999px",
                        padding: "12px",
                        fontFamily: "Quicksand, sans-serif",
                        fontSize: "13px",
                        fontWeight: 700,
                        color: "white",
                        width: "100%",
                        cursor: "pointer",
                        boxShadow: "0 4px 12px rgba(123,220,251,0.3)",
                      }}
                    >
                      Seguir jugando ✨
                    </button>
                  </div>
                );
              })()}

            {/* Slots vacíos con FOMO */}
            {[2, 3].map((pos) =>
              rankings[pos - 1] ? (
                <div
                  key={pos}
                  style={{
                    background: "rgba(255,255,255,0.92)",
                    borderRadius: "16px",
                    border: "1px solid #eee",
                    padding: "10px 14px",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <span
                    style={{
                      fontSize: "13px",
                      fontWeight: 700,
                      color: "#ccc",
                      minWidth: "22px",
                    }}
                  >
                    {pos}
                  </span>
                  <div
                    style={{
                      width: "28px",
                      height: "28px",
                      borderRadius: "50%",
                      background: "#e0d0f0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "11px",
                      fontWeight: 700,
                      color: "#b06ab3",
                    }}
                  >
                    {rankings[pos - 1].username[0].toUpperCase()}
                  </div>
                  <span
                    style={{
                      flex: 1,
                      fontSize: "13px",
                      fontWeight: 600,
                      color: "#333",
                    }}
                  >
                    @{rankings[pos - 1].username}
                  </span>
                  <span
                    style={{
                      fontSize: "13px",
                      fontWeight: 700,
                      color: "#b06ab3",
                    }}
                  >
                    {parseInt(rankings[pos - 1].total).toLocaleString()}
                  </span>
                </div>
              ) : (
                <div
                  key={pos}
                  style={{
                    background: "rgba(255,255,255,0.6)",
                    borderRadius: "16px",
                    border: "1.5px dashed #e0d0f0",
                    padding: "10px 14px",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    opacity: 0.7,
                  }}
                >
                  <span
                    style={{
                      fontSize: "13px",
                      fontWeight: 700,
                      color: "#ddd",
                      minWidth: "22px",
                    }}
                  >
                    {pos}
                  </span>
                  <div
                    style={{
                      width: "28px",
                      height: "28px",
                      borderRadius: "50%",
                      background: "#f0ecf8",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "14px",
                    }}
                  >
                    ?
                  </div>
                  <span
                    style={{
                      flex: 1,
                      fontSize: "12px",
                      color: "#c4b5fd",
                      fontStyle: "italic",
                    }}
                  >
                    ¿Serás tú? 👀
                  </span>
                  <span
                    style={{
                      fontSize: "12px",
                      color: "#e0d0f0",
                      fontWeight: 700,
                    }}
                  >
                    — pts
                  </span>
                </div>
              )
            )}
          </>
        ) : (
          // ── PODIO COMPLETO (3+ usuarios) ──
          <>
            {top3.length > 0 && (
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "center",
                  gap: "8px",
                  padding: "8px 0 10px",
                }}
              >
                {podiumOrder.map((entry, i) => {
                  if (!entry) return <div key={i} style={{ width: "90px" }} />;
                  const color = podiumColors[i];
                  const height = podiumHeights[i];
                  const pos = podiumPositions[i];
                  const isFirst = pos === 1;
                  const initial = entry.username[0].toUpperCase();
                  return (
                    <div
                      key={entry.username}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      <div
                        style={{
                          width: isFirst ? "46px" : "38px",
                          height: isFirst ? "46px" : "38px",
                          borderRadius: "50%",
                          background: color,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: isFirst ? "16px" : "13px",
                          fontWeight: 800,
                          color: "white",
                          position: "relative",
                          boxShadow: isFirst ? `0 4px 12px ${color}60` : "none",
                        }}
                      >
                        {isFirst && (
                          <span
                            style={{
                              position: "absolute",
                              top: "-16px",
                              fontSize: "16px",
                            }}
                          >
                            👑
                          </span>
                        )}
                        {initial}
                      </div>
                      <p
                        style={{
                          fontSize: "10px",
                          fontWeight: 700,
                          color: "#444",
                          textAlign: "center",
                          maxWidth: "70px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        @{entry.username}
                      </p>
                      <p
                        style={{
                          fontSize: "11px",
                          fontWeight: 700,
                          color: "#b06ab3",
                        }}
                      >
                        {parseInt(entry.total).toLocaleString()}
                      </p>
                      <div
                        style={{
                          width: "72px",
                          height,
                          background: color,
                          borderRadius: "8px 8px 0 0",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "16px",
                          fontWeight: 800,
                          color: "white",
                          boxShadow: `0 4px 12px ${color}40`,
                        }}
                      >
                        {pos}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {rest.length > 0 && (
              <div
                style={{ display: "flex", flexDirection: "column", gap: "8px" }}
              >
                {rest.map((entry, i) => {
                  const pos = i + 4;
                  const isMe = user && entry.username === user.username;
                  return (
                    <div
                      key={entry.username}
                      style={{
                        background: isMe
                          ? "rgba(123,220,251,0.1)"
                          : "rgba(255,255,255,0.92)",
                        borderRadius: "16px",
                        border: isMe ? "1.5px solid #7BDCFB" : "1px solid #eee",
                        padding: "10px 14px",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        boxShadow: "0 2px 8px rgba(176,106,179,0.06)",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "13px",
                          fontWeight: 700,
                          color: "#ccc",
                          minWidth: "22px",
                        }}
                      >
                        {pos}
                      </span>
                      <div
                        style={{
                          width: "28px",
                          height: "28px",
                          borderRadius: "50%",
                          background: isMe ? "#7BDCFB" : "#e0d0f0",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "11px",
                          fontWeight: 700,
                          color: isMe ? "white" : "#b06ab3",
                          flexShrink: 0,
                        }}
                      >
                        {entry.username[0].toUpperCase()}
                      </div>
                      <span
                        style={{
                          flex: 1,
                          fontSize: "13px",
                          fontWeight: isMe ? 700 : 600,
                          color: isMe ? "#0e6fa8" : "#333",
                        }}
                      >
                        @{entry.username}
                        {isMe && (
                          <span
                            style={{
                              fontSize: "10px",
                              color: "#7BDCFB",
                              marginLeft: "6px",
                            }}
                          >
                            tú
                          </span>
                        )}
                      </span>
                      <span
                        style={{
                          fontSize: "13px",
                          fontWeight: 700,
                          color: "#b06ab3",
                        }}
                      >
                        {parseInt(entry.total).toLocaleString()}
                      </span>
                    </div>
                  );
                })}
              </div>
            )}

            {user &&
              myStats &&
              !rankings.find((r) => r.username === user.username) && (
                <div
                  style={{
                    background: "rgba(123,220,251,0.1)",
                    border: "1.5px solid #7BDCFB",
                    borderRadius: "16px",
                    padding: "10px 14px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <span
                    style={{ fontSize: "13px", fontWeight: 600, color: "#444" }}
                  >
                    Tu posición
                  </span>
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: 800,
                      color: "#7BDCFB",
                    }}
                  >
                    #{myStats.rank}
                  </span>
                  <span
                    style={{
                      fontSize: "13px",
                      fontWeight: 700,
                      color: "#b06ab3",
                    }}
                  >
                    {myStats.total} pts
                  </span>
                </div>
              )}
          </>
        )}
        {!user && !loading && rankings.length > 0 && (
          <div
            onClick={() => navigate("/login")}
            style={{
              background: "linear-gradient(135deg, rgba(176,106,179,0.08), rgba(123,220,251,0.08))",
              border: "1.5px dashed #c4b5fd",
              borderRadius: "16px",
              padding: "14px 16px",
              display: "flex",
              alignItems: "center",
              gap: "12px",
              cursor: "pointer",
            }}
          >
            <div
              style={{
                width: "36px",
                height: "36px",
                borderRadius: "50%",
                background: "linear-gradient(135deg, #c4b5fd, #f9a8d4)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "16px",
                flexShrink: 0,
              }}
            >
              🏆
            </div>
            <div style={{ flex: 1 }}>
              <p
                style={{
                  fontSize: "13px",
                  fontWeight: 700,
                  color: "#2d1f3d",
                  margin: 0,
                  marginBottom: "2px",
                }}
              >
                ¿Quieres aparecer aquí?
              </p>
              <p
                style={{
                  fontSize: "11px",
                  color: "#9b7eaa",
                  margin: 0,
                }}
              >
                Crea tu cuenta y empieza a sumar puntos 👀
              </p>
            </div>
            <span style={{ fontSize: "16px", color: "#c4b5fd" }}>→</span>
          </div>
        )}
      </div>
    </div>
  );
}
